// Normalize a base64 image string from the backend.
// Some entries are raw base64; others already include "data:image/...;base64,".
// Returns a valid data URL or null if input is empty/invalid.
//
// Also fixes the non-standard "image/jpg" MIME → "image/jpeg" so WeasyPrint
// (strict RFC 6838) can render the logo in the generated PDF.
export function toImageDataUrl(value, fallbackMime = "image/png") {
  if (!value || typeof value !== "string") return null;
  const trimmed = value.trim();
  if (trimmed.length < 10) return null;
  if (trimmed.startsWith("data:")) {
    return trimmed.replace(/^data:image\/jpg;/i, "data:image/jpeg;");
  }
  return `data:${fallbackMime};base64,${trimmed}`;
}

// Strip the "data:image/...;base64," prefix to get raw base64.
export function stripDataUrl(value) {
  if (!value || typeof value !== "string") return value;
  return value.replace(/^data:[^;]+;base64,/, "");
}
